import type { UseHttp } from '~/api/interface'
import OSS from 'ali-oss'

export const fetchOssInfo: UseHttp = (params, option) => {
  return useHttp.get(`/api/oss/info`, undefined, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    ...option
  })
}

export const fetchUploadFileToOss = (params: FormData) => {
  const client = new OSS({
    region: 'oss-cn-shanghai',
    accessKeyId: 'LTAIcsnlOuTz1P1j',
    accessKeySecret: 'qftvfRZ0OLyPbI6WDpqj3OdWZBO5J4',
    bucket: 'jufair'
  })

  return client.put(params.get('key') as string, params.get('file'))
}

export const fetchOSSNewsContent: UseHttp = (params, option) => {
  return useHttp.get(`/ossApi/newsContent/${params?.newsId}.html`, undefined, { ...option })
}

export const fetchOSSInnerChainInfo: UseHttp = (params, option) => {
  return useHttp.get('/ossApi/InnerChainInfo/key.json', undefined, { ...option })
}
